module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-full slidelotes"
  }, [_c('div', {
    staticClass: "col1"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "z-index": "99"
    }
  }, [_c('div', {
    staticClass: "lote-num",
    staticStyle: {
      "background-color": "#212121"
    }
  }, [_c('div', [_vm._v("LOTE")]), _vm._v(" "), _c('div', {
    staticClass: "lote-num-content"
  }, [_vm._v(_vm._s(_vm.lote.numero))])]), _vm._v(" "), _c('div', {
    staticClass: "lote-desc"
  }, [_vm._v("\n        " + _vm._s(_vm.lote.titulo) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    staticStyle: {
      "margin-top": "-20px"
    }
  }, [_c('lote-imagens', {
    attrs: {
      "video": _vm.videoSrc,
      "lote": _vm.lote
    },
    on: {
      "videoEnded": _vm.videoEnded
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col2",
    staticStyle: {
      "background-color": "#5b5959"
    }
  }, [_c('div', {
    staticClass: "t1",
    staticStyle: {
      "margin-top": "-20px"
    }
  }, [_c('span', [_vm._v("Lance Inicial")]), _vm._v(" "), _c('strong', [_vm._v("R$" + _vm._s(_vm._f("moeda")(_vm.lote.valorInicial)))])]), _vm._v(" "), _c('div', {
    staticClass: "t1",
    staticStyle: {
      "margin-top": "-28px"
    }
  }, [_c('span', [_vm._v("Maior Lance")]), _vm._v(" "), _c('strong', [_vm._v("R$" + _vm._s(_vm._f("moeda")(_vm.valor)))])]), _vm._v(" "), _c('div', {
    staticClass: "t1",
    staticStyle: {
      "margin-top": "-48px"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.apelido))])]), _vm._v(" "), _c('div', {
    staticClass: "t1",
    staticStyle: {
      "margin-top": "-28px"
    }
  }, [_c('span', [_vm._v("Tempo ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.timerPregaoFormatado))])]), _vm._v(" "), _c('div', {
    staticClass: "t1"
  }, [_c('span', [_vm._v("Status")]), _vm._v(" "), _c('strong', {
    class: 'status-' + _vm.lote.status
  }, [_vm._v(_vm._s(_vm.statusLote))])]), _vm._v(" "), _c('div', {
    staticClass: "t-comitente",
    staticStyle: {
      "background-color": "#FFFFFF"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.lote.comitente.imagemUrl
    }
  })]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "t-logo",
    staticStyle: {
      "background-color": "#FFFFFF"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/logo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-efe748a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/apresentacao-lotes/Main.vue
// module id = 2020
// module chunks = 3